import styled from 'styled-components';
import goSafeSheildLogoSvg from '../assets/hotels/details/goSafeSheildLogo.svg';

const GoSafeSheildLogo = styled(goSafeSheildLogoSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.fill || props.theme.colors.goBrandBlue.base};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default GoSafeSheildLogo;
